import { render, staticRenderFns } from "./UpsellBundle.vue?vue&type=template&id=85298fd6"
import script from "./UpsellBundle.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpsellBundle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UpsellBundle.vue?vue&type=style&index=0&id=85298fd6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports